export const GetFormatDateType1 = (date = new Date()) => {
    var d = new Date(date);
    var weekday = new Array(7);
    weekday[0] = "Sun";
    weekday[1] = "Mon";
    weekday[2] = "Tue";
    weekday[3] = "Wed";
    weekday[4] = "Thu";
    weekday[5] = "Fri";
    weekday[6] = "Sat";
    var nameDay = weekday[d.getDay()];
    var month = new Array();
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sep";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    var nameMont = month[d.getMonth()];
    return ` ${nameDay},${d.getDate()} ${nameMont} ${d.getFullYear()}`;
}
export const checkDatesBetween = (dateInit, dateEnd, dateEval) => {

    const DataInit = new Date(dateInit);
    const DataEnd = new Date(dateEnd);
    const DateEval = new Date(dateEval);

    return DateEval > DataInit && DateEval < DataEnd
}